"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.default = exports.key = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _NavItem = _interopRequireDefault(require("../utils/NavItem"));

var _sortNavConfig = _interopRequireDefault(require("../utils/sortNavConfig"));

var key = 'SETTINGS_NAV';
exports.key = key;

function parse(config) {
  var sortedConfig = [];

  try {
    if (config && config.children && config.children.length > 0) {
      sortedConfig = (0, _sortNavConfig.default)(config.children).map(function (navItem) {
        return new _NavItem.default(null, navItem);
      });
    }
  } catch (e) {
    console.error(e);
  }

  return sortedConfig;
}

var cachedResult;

var Config =
/*#__PURE__*/
function () {
  function Config() {
    (0, _classCallCheck2.default)(this, Config);
  }

  (0, _createClass2.default)(Config, null, [{
    key: "getLocal",
    value: function getLocal() {
      var config;

      try {
        config = parse(JSON.parse(window.sessionStorage.getItem(key)));
      } catch (e) {
        console.error(e);
      }

      return config;
    }
  }, {
    key: "get",
    value: function get() {
      if (typeof cachedResult === 'undefined') {
        cachedResult = _apiClient.default.get('navconfig/v2/navconfig/settings').then(function (config) {
          var parsedConfig = parse(config);
          setTimeout(function () {
            try {
              window.sessionStorage.setItem(key, JSON.stringify(config));
            } catch (e) {
              console.error(e);
            }
          }, 0);
          return parsedConfig;
        });
      }

      return cachedResult;
    }
  }]);
  return Config;
}();

exports.default = Config;